import React from 'react'
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import scrollimg from "../../../assets/images/scrollimg.png"

// import required modules
import { Navigation, Autoplay } from "swiper";
import styled from '@emotion/styled';
import { Grid } from '@mui/material';

import { Pagination } from "swiper";
const Iasdmg = styled.img`  
width: 100%;
height:auto;
max-width: ${(props) => (props.maxWidth ? props.maxWidth : "250px")};
@media screen and (max-width:900px){
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : "150px")};
}
`
const MainGrid = styled(Grid)`
display: flex;
justify-content: space-between;
background: #73BB61;
padding: 2% 0;
@media screen and (max-width:900px){
  display: grid;
}
`
const GridInside = styled(Grid)`
display: flex;
    place-content: center;
`

const Swipe = (props) => {
    return (
        <div style={{ padding:"20px 0 10px",backgroundColor: "#73BB61" }} >
            {/* <Swiper autoplay loop={true} slidesPerView={6}
                spaceBetween={0}
                centeredSlides={true}
                pagination={{
                    clickable: true,
                }}
                modules={[Pagination]}
                className="mySwiper" */}

                <marquee scrollamount={props.scrollamount} behavior="scroll" direction="left" loop="infinite"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="300"
                data-aos-offset="0"
                data-aos-duration="500"
            >
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />
                <Iasdmg alt="Logo" src={scrollimg} />

            </marquee>
        </div>
    )
}

export default Swipe